import { put, takeLatest } from 'redux-saga/effects';
import studentActionTypes from '../types';
import { downloadStudentDocFail } from '../action';
import httpClient from '../../../utils/http-client';
import { handleError } from '../../../utils/utils';
import { Notify } from '@flexisaf/flexibull2';

export function* downloadStudentDocument({ payload }) {
  const { data, document_name } = payload;
  try {
    const response = yield httpClient.post('/documents/download', data, { responseType: 'blob' });
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `${document_name}`);
    document.body.appendChild(link);
    link.click();
  } catch (error) {
    yield put(downloadStudentDocFail(error?.message));
    const err = handleError(error);
  }
}

export function* onDownloadStudentDocStart() {
  yield takeLatest(studentActionTypes.DOWNLOAD_STUDENT_DOCS_START, downloadStudentDocument);
}
